import { useState, useCallback } from 'react'
import { getUserLimits } from 'src/api/limit'
import { LimitTypeEnum } from 'src/model/limit'

export const useAiState = () => {
  const [aiState, setAiState] = useState({
    count: 0,
    limit: 0,
    loading: true,
    refreshedAt: null,
  })

  const setAiCount = useCallback(count => {
    setAiState(prev => ({ ...prev, count }))
  }, [])

  const handleLoading = useCallback(loading => {
    setAiState(prev => ({ ...prev, loading }))
  }, [])

  const fetchLimits = useCallback(async () => {
    setAiState(prev => ({ ...prev, loading: true }))
    try {
      const response = await getUserLimits()
      const aiData = response.data.find(
        x => x.limit.type === LimitTypeEnum.AICourseCreation,
      )
      setAiState({
        count: aiData.count,
        limit: aiData.limit.upperLimit,
        loading: false,
        refreshedAt: aiData.refreshedAt,
      })
    } catch (error) {
      console.error('Error fetching limits:', error)
      setAiState(prev => ({ ...prev, loading: false }))
    }
  }, [])

  return { aiState, setAiCount, handleLoading, fetchLimits }
}
